import { render, staticRenderFns } from "./NamespaceOverview.vue?vue&type=template&id=dc6e5d34&scoped=true"
import script from "./NamespaceOverview.vue?vue&type=script&lang=js"
export * from "./NamespaceOverview.vue?vue&type=script&lang=js"
import style0 from "./NamespaceOverview.vue?vue&type=style&index=0&id=dc6e5d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6e5d34",
  null
  
)

export default component.exports